import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ProtectedRoute from '../../routes/protected'
import SidebarCargosSalarios from '../../components/sidebars/sidebarCargosSalarios'
import salaryAnalysisService from '../../services/data/salary-analysis.service'
import companyService from '../../services/data/company.service'
import currencyFormat from '../../helpers/currencyFormat'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { Dropdown } from 'primereact/dropdown'

export default function CargosSalariosDashboard() {
    const [kpis, setKpis] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')

    const [subcompanySel, setSubcompanySel] = useState(null)
    const [departmentSel, setDepartmentSel] = useState(null)
    const [subcompanyItems, setSubcompanyItems] = useState([])
    const [departmentItems, setDepartmentItems] = useState([])

    function buildFilters() {
        const f = {}
        if (subcompanySel) f.subcompany_id = subcompanySel.id
        if (departmentSel) f.department_id = departmentSel.id
        return f
    }

    function loadKpis(filters = {}) {
        setLoading(true)
        setError('')
        salaryAnalysisService.getDashboard(filters)
            .then(setKpis)
            .catch(e => setError(JSON.stringify(e?.response?.data || e)))
            .finally(() => setLoading(false))
    }

    useEffect(() => { loadKpis() }, [])
    useEffect(() => {
        companyService.autoCompleteSubCompany('')
            .then(r => setSubcompanyItems(r || []))
            .catch(() => setSubcompanyItems([]))
        companyService.autoCompleteDepartment('')
            .then(r => setDepartmentItems(r || []))
            .catch(() => setDepartmentItems([]))
    }, [])

    function applyFilters() { loadKpis(buildFilters()) }

    function clearFilters() {
        setSubcompanySel(null)
        setDepartmentSel(null)
        loadKpis()
    }

    const _statusColor = (pct, inverse = false) => {
        if (pct === null || pct === undefined) return 'text-muted'
        if (inverse) return pct > 10 ? 'text-danger' : pct > 5 ? 'text-warning' : 'text-success'
        return pct >= 80 ? 'text-success' : pct >= 50 ? 'text-warning' : 'text-danger'
    }

    return (
        <ProtectedRoute>
            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <SidebarCargosSalarios />
                    <div className="col-xs-10 col-sm-9 col-md-9 col-xl-10 p-0 formMarginBottom">
                        <div className='col text-bg-green p-3'>
                            <span className="fs-6 fw-bold">Cargos & Salários — Dashboard</span>
                        </div>

                        {/* Filtros */}
                        <div className='row m-3 g-2 align-items-end'>
                            <div className='col-md-3'>
                                <label className='form-label small fw-bold'>Organização</label>
                                <Dropdown
                                    className='w-100'
                                    placeholder='Filtrar por organização'
                                    value={subcompanySel}
                                    options={subcompanyItems}
                                    optionLabel='title'
                                    filter
                                    showClear
                                    onChange={e => setSubcompanySel(e.value)}
                                />
                            </div>
                            <div className='col-md-3'>
                                <label className='form-label small fw-bold'>Departamento</label>
                                <Dropdown
                                    className='w-100'
                                    placeholder='Filtrar por departamento'
                                    value={departmentSel}
                                    options={departmentItems}
                                    optionLabel='title'
                                    filter
                                    showClear
                                    onChange={e => setDepartmentSel(e.value)}
                                />
                            </div>
                            <div className='col-auto'>
                                <button className='btn btn-success btn-sm' onClick={applyFilters}>
                                    <FontAwesomeIcon icon={solid('magnifying-glass')} /> Filtrar
                                </button>
                            </div>
                            <div className='col-auto'>
                                <button className='btn btn-link btn-sm text-grey text-decoration-none' onClick={clearFilters}>
                                    Limpar
                                </button>
                            </div>
                        </div>

                        {error && <div className='alert alert-danger mx-3'>{error}</div>}

                        {loading && (
                            <div className='text-center p-5'>
                                <div className="spinner-border text-success" role="status" />
                            </div>
                        )}

                        {!loading && kpis && (
                            <>
                                {/* KPI Cards */}
                                <div className='row m-3 g-3'>
                                    <div className='col-md-4 col-lg-2'>
                                        <div className='card border-clean h-100'>
                                            <div className='card-body text-center'>
                                                <div className='text-muted small'>Posições Previstas</div>
                                                <div className='fs-4 fw-bold text-default'>{kpis.total_expected_positions}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4 col-lg-2'>
                                        <div className='card border-clean h-100'>
                                            <div className='card-body text-center'>
                                                <div className='text-muted small'>Posições Ocupadas</div>
                                                <div className='fs-4 fw-bold text-success'>{kpis.total_occupied_positions}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4 col-lg-2'>
                                        <div className='card border-clean h-100'>
                                            <div className='card-body text-center'>
                                                <div className='text-muted small'>Vagas Abertas</div>
                                                <div className={`fs-4 fw-bold ${kpis.total_open_positions > 0 ? 'text-warning' : 'text-success'}`}>
                                                    {kpis.total_open_positions}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4 col-lg-3'>
                                        <div className='card border-clean h-100'>
                                            <div className='card-body text-center'>
                                                <div className='text-muted small'>Massa Salarial Total</div>
                                                <div className='fs-5 fw-bold text-default'>{currencyFormat(kpis.total_salary_mass)}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4 col-lg-3'>
                                        <div className='card border-clean h-100'>
                                            <div className='card-body'>
                                                <div className='text-muted small mb-2'>Status vs. Faixa</div>
                                                <div className='d-flex justify-content-between'>
                                                    <span className='badge bg-success'>{kpis.pct_within_range}% Dentro</span>
                                                    <span className='badge bg-danger'>{kpis.pct_above_range}% Acima</span>
                                                    <span className='badge bg-warning text-dark'>{kpis.pct_below_range}% Abaixo</span>
                                                </div>
                                                <div className='progress mt-2' style={{height: 8}}>
                                                    <div className='progress-bar bg-success' style={{width: `${kpis.pct_within_range}%`}} />
                                                    <div className='progress-bar bg-danger' style={{width: `${kpis.pct_above_range}%`}} />
                                                    <div className='progress-bar bg-warning' style={{width: `${kpis.pct_below_range}%`}} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {((kpis.employees_without_salary_count || 0) > 0 || (kpis.employees_without_salary_preview || []).length > 0) && (
                                    <div className='row m-3 g-3'>
                                        <div className='col-12'>
                                            <div className={`card border-clean ${(kpis.employees_without_salary_count || 0) > 0 ? 'border-warning' : ''}`}>
                                                <div className='card-body'>
                                                    <div className='d-flex flex-wrap justify-content-between align-items-start gap-2 mb-2'>
                                                        <div>
                                                            <h6 className='fw-bold mb-1'>
                                                                <FontAwesomeIcon icon={solid('user-clock')} className='me-2 text-warning' />
                                                                Colaboradores sem salário registrado
                                                            </h6>
                                                            <p className='text-muted small mb-0'>
                                                                Alocados em posição, sem registro ativo de salário para análise de faixa.
                                                                {kpis.can_manage_employee_salaries ? ' Lista conforme seu acesso de gestão.' : ' Exibindo apenas pendências do seu próprio cadastro, quando houver.'}
                                                            </p>
                                                        </div>
                                                        <Link to='/cargos-salarios/registrar-salarios/' className='btn btn-success btn-sm btn-rounded'>
                                                            <FontAwesomeIcon icon={solid('pen-to-square')} className='me-1' />
                                                            Registrar salários
                                                        </Link>
                                                    </div>
                                                    <p className='mb-2'>
                                                        <span className='fs-4 fw-bold text-default'>{kpis.employees_without_salary_count}</span>
                                                        <span className='text-muted small ms-2'>pendência(s) no filtro atual</span>
                                                    </p>
                                                    {(kpis.employees_without_salary_preview || []).length > 0 && (
                                                        <ul className='list-group list-group-flush border rounded small'>
                                                            {(kpis.employees_without_salary_preview || []).map(row => (
                                                                <li key={row.employee_id} className='list-group-item d-flex justify-content-between align-items-center flex-wrap gap-1'>
                                                                    <span className='fw-semibold'>{row.employee_name}</span>
                                                                    <span className='text-muted'>{(row.position_titles || []).join(' · ') || '—'}</span>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Detalhamento status */}
                                <div className='row m-3 g-3'>
                                    <div className='col-12'>
                                        <div className='card border-clean'>
                                            <div className='card-body'>
                                                <h6 className='fw-bold mb-3'>Distribuição de Cargos por Status Salarial</h6>
                                                <div className='row g-3 text-center'>
                                                    <div className='col-md-3'>
                                                        <div className='p-3 rounded' style={{background: '#d4edda'}}>
                                                            <div className='fs-3 fw-bold text-success'>{kpis.count_within_range}</div>
                                                            <div className='small text-success fw-bold'>Dentro da Faixa</div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <div className='p-3 rounded' style={{background: '#f8d7da'}}>
                                                            <div className='fs-3 fw-bold text-danger'>{kpis.count_above_range}</div>
                                                            <div className='small text-danger fw-bold'>Acima da Faixa</div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <div className='p-3 rounded' style={{background: '#fff3cd'}}>
                                                            <div className='fs-3 fw-bold text-warning'>{kpis.count_below_range}</div>
                                                            <div className='small text-warning fw-bold'>Abaixo da Faixa</div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-3'>
                                                        <div className='p-3 rounded' style={{background: '#e2e3e5'}}>
                                                            <div className='fs-3 fw-bold text-secondary'>{kpis.count_no_structure}</div>
                                                            <div className='small text-secondary fw-bold'>Sem Estrutura</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </ProtectedRoute>
    )
}
